import { string, object } from 'yup';

const schema = object().shape({
  name: string().required('requiredField'),
  email: string().required('requiredField').email('invalidEmailAddress')

});

export default schema;